import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import InitiativeValidations from 'scaleflow/validators/initiative';

export default class InitiativesInitiativeSelectorComponent extends Component {
  @service store;
  @tracked showDropdown = false;
  initiativeValidations = InitiativeValidations;

  @action isSelected(initiative) {
    return this.initiative.id == initiative.id;
  }

  @action
  toggleDropdown(val) {
    if (val === undefined) this.showDropdown = !this.showDropdown;
    else this.showDropdown = val;
  }

  @action
  handleInitiativeSelect(initiative) {
    this.toggleDropdown(false);
    this.args?.propagateInitiativeSelect?.(initiative);
  }

  get initiative() {
    return this.args.initiative;
  }

  get initiatives() {
    return this.store.peekAll('initiative');
  }
}
